export const infrastructureSchema = {
  type: '',
  backbone: {
    planned: false,
    installed: false
  },
  leadIn: {
    planned: false,
    installed: false
  },
  customerAccessCabling: {
    planned: false,
    installed: false
  },
  gPOinMDF: {
    planned: false,
    installed: false,
    exist: false
  },
  uPSinMDF: {
    planned: false,
    installed: false
  },
  gPOinRisers: {
    planned: false,
    installed: false,
    exist: false
  },
  uPSinRisers: {
    planned: false,
    installed: false
  }
}

// export const infrastructureFields = ['backbone', 'leadIn', 'gPOinMDF', 'uPSinMDF']

// export const infrastructureTitles = ['Backbone', 'Lead In', 'GPO in MDF', 'UPS in MDF']
